import React from 'react';

import { Col } from 'react-bootstrap';

class Help extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="panel-page-internal">
				<div className="bg-blue shadow">
					<div className="container-secondary text-white">
						<Col md={12}>
							<h1 className="text-bold">Ajuda</h1>
							<h2 className="text-light">Tire todas as suas dúvidas e fique por dentro de como acumular mais cupons e concorrer aos prêmios!</h2>
						</Col>
					</div>
				</div>
				<div className="container-secondary bg-white text-area">
					<Col md={12}>
						<div className="clearfix">
							<h2>O que é o Jogada Musical?</h2>
							<p>É uma promoção com assinatura para clientes da Claro, onde é possível testarem seus conhecimentos sobre o mundo da música e juntar pontos que se transformam em cupons, para participar de sorteios mensais de R$10 mil ou experiências incríveis com artistas selecionados.</p>
						</div>

						<div className="clearfix">
							<h2>Qual é a duração da Promoção?</h2>
							<p>A Promoção terá início em 24/07/2019 e fim em 31/08/2024 às 23h59.</p>
						</div>
						<div className="clearfix">
							<h2>Como faço para participar?</h2>
							<p>Basta enviar um SMS com a palavra ATIVE para o número 7979 para ativar sua assinatura. Você não paga nada na primeira semana e já ganha 1 (um) cupom para o sorteio mensal. A partir de então você tem acesso a 5 (cinco) perguntas por dia sobre o mundo da música. Caso queira responder a mais perguntas para conseguir mais cupons, basta enviar ‘MAIS’ para 7979. Para cancelar sua assinatura quando quiser, envie &apos;SAIR&apos; para 7979 e sua assinatura será cancelada.</p>
						</div>
						<div className="clearfix">
							<h2>O que é o período grátis?</h2>
							<p>Para que você possa experimentar o serviço Jogada Musical, os primeiros 3 dias da sua assinatura são inteiramente grátis.</p>
						</div>
						<div className="clearfix">
							<h2>Qual é o valor da assinatura?</h2>
							<p>A assinatura do serviço Jogada Musical custa R$4,99 por semana.</p>
						</div>
						<div className="clearfix">
							<h2>Quais são os prêmios oferecidos pela Jogada Musical?</h2>
							<p>Você concorre a um prêmio mensal de R$10.000 em dinheiro, que pode ser convertido em experiências com artistas pré-definidos. Maiores detalhes estão no Regulamento da Promoção.</p>
						</div>
						<div className="clearfix">
							<h2>Quando os sorteios são realizados e quem realiza os sorteios?</h2>
							<p>Os sorteios são realizados pela Loteria Federal. Também é possível verificar as datas dos sorteios no Regulamento da Promoção.</p>
						</div>
						<div className="clearfix">
							<h2>Como faço para saber se ganhei mesmo o cupom para o sorteio e o número do cupom?</h2>
							<p>Através do site, você poderá consultar seus CUPONS na sessão chamada CUPONS.</p>
							<p>Através de SMS, basta enviar a palavra SALDO para 7979 e receber a quantidade total de CUPONS.</p>
						</div>
						<div className="clearfix">
							<h2>Como posso cancelar a minha assinatura?</h2>
							<p>Basta enviar a palavra SAIR para 7979.<br />Mesmo após cancelar o serviço, os cupons que você tiver
								e que ainda não expiraram, continuarão valendo para os sorteios aos quais você tem direito.</p>
						</div>
						<div className="clearfix">
							<h2>Sou um dos sorteados, mas não quero que meu nome seja divulgado na mídia. O que fazer?</h2>
							<p>Conforme explicitado no Regulamento da promoção, a participação implica na aceitação das regras
								referentes à divulgação de dados dos ganhadores.</p>
						</div>
						<div className="clearfix">
							<h2>O que acontece se um participante entrar na promoção com o celular de outra pessoa?</h2>
							<p>É presumido que cada participante é proprietário da linha (cartão SIM) ou, em outro caso, tem
								expressa autorização do proprietário da linha para participar da promoção. Porém, independente de
								quem participar, a premiação só poderá ser entregue ao proprietário da linha telefônica, mediante
								apresentação de documentos comprobatórios.</p>
						</div>
						<div className="clearfix">
							<h2>De que maneira os sorteados são notificados?</h2>
							<p>As tentativas de contato serão realizadas através do número telefônico participante da promoção, em
								uma ligação de voz. Nenhuma notificação de premiação será feita através de SMS ou será requerido
								qualquer tipo de pagamento para a liberação do prêmio.<br /><br /> Havendo qualquer dúvida,
								verificar os nomes dos ganhadores no site: www.jogadamusical.com</p>
						</div>
						<div className="clearfix">
							<h2>Onde serão divulgados os ganhadores?</h2>
							<p>Os nomes dos ganhadores serão divulgados no site www.jogadamusical.com</p>
						</div>
						<div className="clearfix">
							<h2>Enviei uma mensagem SMS, mas não recebi um SMS de resposta.</h2>
							<p>Caso você não obtenha nenhum retorno, por favor entre em contato através do e-mail
								sac@imusica.com.br, informando o ocorrido.</p>
						</div>
						<div className="clearfix">
							<h2>Posso participar usando diferentes números de celulares?</h2>
							<p>Você pode utilizar mais de um número para participar, porém, cada número será uma assinatura
								completamente diferente.</p>
						</div>
						<div className="clearfix">
							<h2>As minhas participações podem ser transferidas caso eu mude de cartão SIM (ou seja, meu número de
								telefone)?</h2>
							<p>Infelizmente não, a sua participação está inteiramente atrelada ao seu número de telefone.</p>
						</div>
						<div className="clearfix">
							<h2>Onde posso encontrar o Regulamento da Promoção?</h2>
							<p>Acesse a página REGULAMENTO, neste website.</p>
						</div>
						<div className="clearfix">
							<h2>Em caso de envio de dúvidas, sugestões e reclamações, como posso entrar em contato?</h2>
							<p>Você pode enviar qualquer dúvida, sugestão ou reclamação para o e-mail sac@imusica.com.br</p>
						</div>
						<div className="clearfix">
							<h2>Quais os comandos por SMS do serviço?</h2>
							<p>Você pode conhecer melhor o serviço direto do seu celular, enviando para 7979 alguma das palavras
								abaixo:</p>
							<ul>
								<li>JOGAR para iniciar sua rodada do dia;</li>
								<li>USAR para saber como funciona a mecânica do jogo;</li>
								<li>AJUDA para saber mais sobre o serviço;</li>
								<li>SALDO para saber o seu número de cupons;</li>
								<li>SAIR para cancelar.</li>
							</ul>
						</div>
					</Col>
				</div>
			</div>
		);
	}
}

export default Help;


// WEBPACK FOOTER //
// ./src/components/pages/help.component.jsx